import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import { CompetitorProps } from '../MatchTypes'
import Image from '../../../BaseComponents/Image'
import CaptionFont from '../../../Theme/Fonts/Caption'
import SmallBodyFont from '../../../Theme/Fonts/SmallBody'
import { TestID } from '../../../utils/PropTypesDefinitions'
import { mapSpaceValue } from '../../../Layouts/LayoutUtils'
import { Spacing } from '../../../Layouts/LayoutTypes'
import ButtonFont from '../../../Theme/Fonts/Button'
import { veryThinSpace } from '../PostMatch'
import MatchStatusCompetitorImage from './HelperClass/CompetitorImage'

export type BasicMatchStatusProps = {
    /** home competitor object, will be displayed on the left */
    homeCompetitor: Exclude<CompetitorProps, 'onPress' | 'href'>
    /** away competitor object, will be displayed on the right */
    awayCompetitor: Exclude<CompetitorProps, 'onPress' | 'href'>
    /** score of the home competitor */
    homeScore: string | number
    /** score of the away competitor */
    awayScore: string | number
    /** headline text */
    headline: string
    /** optional spacer (left and right) */
    spaceX?: Spacing | Spacing[]
    /** optional spacer (top) */
    spaceTop?: Spacing | Spacing[]
    /** optional spacer (bottom) */
    spaceBottom?: Spacing | Spacing[]
} & TestID

export type CompetitorType = 'PLAYER' | 'TEAM'

type MatchStatusProps = BasicMatchStatusProps & {
    logoUrl?: string
    logoAlt?: string
    logoTintColor?: 'white'
    backgroundColor: 'basra' | 'onyx-2'
    competitorType: CompetitorType
}

const MatchStatus: FunctionComponent<MatchStatusProps> = ({
    homeCompetitor,
    awayCompetitor,
    homeScore,
    awayScore,
    logoAlt,
    logoUrl,
    logoTintColor,
    headline,
    backgroundColor,
    spaceX,
    spaceBottom,
    spaceTop,
    competitorType,
    testID,
}) => {
    return (
        <Grid
            testID={testID}
            paddingX={5}
            paddingY={4}
            border={1}
            borderRadius={4}
            borderColor="keshi-2"
            backgroundColor={backgroundColor}
            marginX={mapSpaceValue(spaceX)}
            marginBottom={mapSpaceValue(spaceBottom)}
            marginTop={mapSpaceValue(spaceTop)}
        >
            <Grid horizontal paddingBottom={3}>
                <Image
                    imageUrl={logoUrl}
                    width={16}
                    aspectRatio="1:1"
                    alt={logoAlt}
                    size="L"
                    tintColor={logoTintColor}
                />
                <CaptionFont paddingLeft={3} color="WHITE">{`${headline}`}</CaptionFont>
            </Grid>
            <Grid horizontal centerVertical>
                <Grid minWidth={0}>
                    <Touchable onPress={homeCompetitor.onPress} href={homeCompetitor.href}>
                        <Grid minWidth={0} horizontal>
                            <Grid minWidth={0} paddingRight="6px">
                                <SmallBodyFont
                                    textAlign="right"
                                    color="WHITE"
                                    bold={homeCompetitor.isBold}
                                    numberOfLines={1}
                                >
                                    {homeCompetitor.name}
                                </SmallBodyFont>
                            </Grid>
                            <MatchStatusCompetitorImage
                                type={competitorType}
                                imageUrl={homeCompetitor.logoUrl}
                                alt={homeCompetitor.logoAlt}
                            />
                        </Grid>
                    </Touchable>
                </Grid>
                <Grid noExpand width={72}>
                    <ButtonFont
                        color="WHITE"
                        fontSize="FS16"
                        lineHeight="LH20"
                    >{`${homeScore}${veryThinSpace}:${veryThinSpace}${awayScore}`}</ButtonFont>
                </Grid>
                <Grid minWidth={0}>
                    <Touchable onPress={awayCompetitor.onPress} href={awayCompetitor.href}>
                        <Grid minWidth={0} horizontal>
                            <MatchStatusCompetitorImage
                                type={competitorType}
                                imageUrl={awayCompetitor.logoUrl}
                                alt={awayCompetitor.logoAlt}
                            />
                            <Grid minWidth={0} paddingLeft="6px">
                                <SmallBodyFont
                                    color="WHITE"
                                    bold={awayCompetitor.isBold}
                                    textAlign="left"
                                    numberOfLines={1}
                                >
                                    {awayCompetitor.name}
                                </SmallBodyFont>
                            </Grid>
                        </Grid>
                    </Touchable>
                </Grid>
            </Grid>
        </Grid>
    )
}
export default MatchStatus
